module.exports = __webpack_public_path__ + "img/lr-cb66-n1-3p.f9a88d55.gif";